import styled from "styled-components";
import { ResponsiveBlock } from "components/ResponsiveBlock";

export const StyledResponsiveBlock = styled(ResponsiveBlock)`
    display: grid;
    grid-gap: 20px;
    margin-bottom: 10px;
`;
